import { MODEL_PROVIDER_LABELS } from '@reflex/shared';
import { ModelProviderIcon } from './ModelProviderIcon';
import { EntityChip } from './EntityChip';

const PROVIDER_LABELS: Record<string, string> = MODEL_PROVIDER_LABELS;

export interface ProviderChipProps {
  /** Canonical provider id (e.g. `anthropic`, `openai`, `xai`). */
  provider: string;
  /** Optional override label; falls back to the canonical provider label. */
  name?: string;
  className?: string;
  'data-testid'?: string;
}

/**
 * Standardized chip for a model provider. Shows the provider brand icon and
 * canonical label, with a hover preview resolved through the `providers`
 * resource-preview kind.
 */
export function ProviderChip({
  provider,
  name,
  className,
  'data-testid': dataTestId,
}: ProviderChipProps) {
  const label = name ?? PROVIDER_LABELS[provider] ?? provider;
  return (
    <EntityChip
      kind="providers"
      id={provider}
      icon={<ModelProviderIcon provider={provider} />}
      label={label}
      className={className}
      data-testid={dataTestId}
    />
  );
}
